import styled from 'styled-components';

import fieldBase from './fieldBase';

export default styled.textarea`
  ${fieldBase}
  height: auto;
  resize: none;
`;
